/**
 * Function to truncate SHAs. 
 */

    // This could become a config option at some point
    var SHA_LENGTH = 8;

    function format_sha(sha) {
        // Allow for null or non-string values. Sometimes drafts come with
        // no sha, and this seems like the easiest place to do this
        if (!(sha && sha.substr)) sha = '';
        return sha.substr(0, SHA_LENGTH);
    }

    export default format_sha;

